export const SUCCESS_ARCHIVE_NOTIFICATION = {
  title: 'Archive Success',
  message: 'Configuration has been archived',
  type: 'success',
};

export const ERROR_ARCHIVE_NOTIFICATION = {
  title: 'Archive Error',
  message: 'Configuration has NOT been archived',
  type: 'error',
};

export const COMMON_STEPS = {
  PLATFORM: {
    stepId: 'platform',
    stepTitle: 'Platform & Type',
  },
  OPPORTUNITY: {
    stepId: 'opportunity',
    stepTitle: 'Opportunity',
  },
  DETAILS: {
    stepId: 'details',
    stepTitle: 'Configuration Details',
  },
  PARTS: {
    stepId: 'parts',
    stepTitle: 'Parts & Export',
  },
};

export const NEW_CONFIG_STEPS = [
  {
    order: 0,
    passed: true,
    group: 'General',
    ...COMMON_STEPS.PLATFORM,
    rightButtons: ['next'],
  },
  {
    order: 1,
    passed: true,
    group: 'General',
    ...COMMON_STEPS.OPPORTUNITY,
    rightButtons: ['back', 'next'],
  },
  {
    order: 2,
    passed: true,
    group: 'General',
    ...COMMON_STEPS.DETAILS,
    rightButtons: ['back', 'next'],
  },
];

export const CONFIGURATION_TYPES = {
  NEW: {
    id: 'NewDeployment',
    title: 'New Deployment',
    value: 'New Deployment',
  },
  UPGRADE: {
    id: 'Upgrades',
    title: 'Upgrades',
    value: 'Upgrades/Addon to existing deployments',
  },
  HYBRID: {
    title: 'New deployment or upgrade',
    value: 'New Deployment',
  },
};

export const PLATFORMS = {
  GUARDIUM: 'Guardium',
  QRADAR: 'QRadar',
  RESILIENT: 'Resilient',
};

export const CONFIGURATION_TYPES_BY_PLATFORM = {
  [PLATFORMS.GUARDIUM]: [CONFIGURATION_TYPES.NEW],
  [PLATFORMS.QRADAR]: [CONFIGURATION_TYPES.NEW, CONFIGURATION_TYPES.UPGRADE],
  [PLATFORMS.RESILIENT]: [CONFIGURATION_TYPES.NEW],
};

export const CREATE_CONFIGURATION_PLATFORMS = [
  {
    title: 'Data (Guardium, Encryption, Key Mgmt)',
    value: PLATFORMS.GUARDIUM,
    redirect: 'guardium',
  },
  {
    title: 'QRadar / Security Intelligence Enterprise Bundles',
    value: PLATFORMS.QRADAR,
    redirect: 'qradar',
  },
  {
    title: 'Resilient',
    value: PLATFORMS.RESILIENT,
    redirect: 'resilient',
  },
];
